import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { CanvasserDetail } from '@/components/analytics';
import { useCanvasserStats, useShifts, useContactAnalytics, useCanvasserPerformance } from '@/hooks/queries';
import type { CanvasserAnalyticsFilters } from '@/lib/queryKeys';
import { ReadNotice } from '@/components/ui';
import { isLoading, readyData } from '@/lib/readParts';

export const Route = createFileRoute('/app/analytics/canvassers/$userId')({
  component: CanvasserDetailRoute,
});

function CanvasserDetailRoute() {
  const { userId } = Route.useParams();
  const filters = Route.useSearch() as CanvasserAnalyticsFilters;
  const navigate = useNavigate();

  const statsRead = useCanvasserStats({ ...filters, userId });
  const canvasserStatsResponse = readyData(statsRead);
  const canvasserStats = canvasserStatsResponse?.items;
  const benchmarks = canvasserStatsResponse?.benchmarks;
  const shifts = useShifts({
    claimedById: userId,
    startDate: filters.dateFrom,
    endDate: filters.dateTo,
  });
  const contactRead = useContactAnalytics(userId);
  const performanceRead = useCanvasserPerformance(userId);
  const unready = [statsRead, contactRead, performanceRead].find((r) => r.status === 'failed' || r.status === 'offline');

  const handleBack = () => {
    navigate({
      to: '/app/analytics',
      search: filters,
    });
  };

  return (
    <>
    {unready && <ReadNotice read={unready} subject="some of this canvasser's analytics" />}
    <CanvasserDetail
      userId={userId}
      canvasserStats={canvasserStats ?? []}
      shifts={shifts}
      contactAnalytics={readyData(contactRead)}
      isLoadingStats={isLoading(statsRead)}
      isLoadingContacts={isLoading(contactRead)}
      onBack={handleBack}
      benchmarks={benchmarks}
      performanceData={readyData(performanceRead)}
      isLoadingPerformance={isLoading(performanceRead)}
    />
    </>
  );
}
